(function () {
  const settingsDescriptions = [...document.querySelectorAll('[data-setting-description]')];
  const onClick = ({ currentTarget }) => {
    if (currentTarget.classList.contains('active')) {
      return;
    }

    const {
      dataset: { settingDescription },
      parentElement
    } = currentTarget;

    parentElement.querySelector('[data-setting-description].active').classList.remove('active');
    parentElement.nextElementSibling.querySelector('.active').classList.remove('active');
    parentElement.nextElementSibling.querySelector(`[data-setting-image=${settingDescription}]`).classList.add('active');
    currentTarget.classList.add('active');
  }
 
  settingsDescriptions.map((item) => {
    item.onclick = onClick;
  })
})()